/** Spreadsheets are read in the browser; nothing in them leaves the device. */
export const ATTENDEE_SHEET_EXTENSIONS = [".csv", ".xlsx", ".xls"] as const;

/** Documents are sent for processing: the text is extracted, then read for home cities. */
export const ATTENDEE_DOCUMENT_EXTENSIONS = [".pdf", ".docx", ".doc"] as const;

/** MIME types a document upload may declare; the bytes are checked again on the server. */
export const ATTENDEE_DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
] as const;

/** Largest document sent for processing. */
export const MAX_ATTENDEE_DOCUMENT_BYTES = 10 * 1024 * 1024;

/** Where a document waits between the browser's upload and its processing; deleted right after. */
export const ATTENDEE_UPLOAD_BUCKET = "event_attachments";

/** The folder in {@link ATTENDEE_UPLOAD_BUCKET}; the caller's user id follows it, so only they can process it. */
export const ATTENDEE_UPLOAD_PREFIX = "estimate-attendees";

/** The route that turns an uploaded document into home cities. */
export const ATTENDEE_EXTRACT_API_PATH = "/api/enterprise/estimate/attendees";

/** Document extractions per user: each one is a paid parse and a model call. */
export const ATTENDEE_EXTRACT_RATE_LIMIT = { windowMs: 10 * 60_000, maxCalls: 20 } as const;

/** Text read from a document before it is given to the model; a roster is far shorter. */
export const ATTENDEE_EXTRACT_MAX_TEXT_CHARS = 200_000;

/** The model that reads home cities out of a roster's text, the newest the repo extracts with. */
export const ATTENDEE_EXTRACT_MODEL = "claude-sonnet-5-5";

/** A roster is a list, not a reasoning task. */
export const ATTENDEE_EXTRACT_EFFORT = "low";

/** Room for a few hundred cities with counts. */
export const ATTENDEE_EXTRACT_MAX_TOKENS = 8192;

/** Reducto parse plus the model call, well inside the route's 300s. */
export const ATTENDEE_EXTRACT_TIMEOUT_MS = 240_000;

/** How long the server's read link to an uploaded document lives. */
export const ATTENDEE_UPLOAD_READ_TTL_SECONDS = 600;

/** An upload older than this never reached processing (its route deletes it within 300s); the sweep removes it. */
export const ATTENDEE_UPLOAD_MAX_AGE_MS = 30 * 60_000;

/** Storage entries listed per page while sweeping stale uploads. */
export const ATTENDEE_UPLOAD_SWEEP_PAGE_SIZE = 1000;

/** The chat's attach button names what it reads, since its only face is a paperclip. */
export const ATTENDEE_ATTACH_HINT = "Attach an attendee list: CSV, Excel, PDF or Word";
